module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noFreeText":"There are no free texts yet."},"no":{"noFreeText":"Det er ingen fritekster ennå."}}')
  delete Component.options._Ctor
}
